export default function (value) {
  if (!value)
    return true;

  value = String(value).replace(/[^\d]+/g, '');

  if (value.length < 10) {
    return false;
  }

  let list = [
    '00000000',
    '11111111',
    '22222222',
    '33333333',
    '44444444',
    '55555555',
    '66666666',
    '77777777',
    '88888888',
    '99999999',
  ];

  if (list.indexOf(value.substr(-8)) !== -1) {
      return false;
  }

  if (value.length === 11) {
    list = [
      '00000000000',
      '11111111111',
      '22222222222',
      '33333333333',
      '44444444444',
      '55555555555',
      '66666666666',
      '77777777777',
      '88888888888',
      '99999999999',
    ];
  }

  return list.indexOf(value) === -1;
};
